export default PROMO
